import { createSelector } from 'reselect';
import { getFreeRate } from 'services/billing';

import { StoreState } from '../types/store';

export const getCheckoutSlice = (state: StoreState) => state.checkout;

export const getAmountEmployee = (state: StoreState) => {
    return getCheckoutSlice(state).amountEmployee;
};

export const getCheckoutChosenRate = (state: StoreState) =>
    getCheckoutSlice(state).chosenRate;

export const getCheckoutChosenRateInformation = (state: StoreState) =>
    getCheckoutSlice(state).chosenRateInformation;

export const getRecommendedWebRate = (state: StoreState) =>
    getCheckoutSlice(state).recommendedWebRate;

export const getCheckoutRates = (state: StoreState) =>
    getCheckoutSlice(state).rates;

export const getCheckoutArchiveRates = (state: StoreState) =>
    getCheckoutRates(state)?.rates_archive;

export const getFreeRateSelector = createSelector(getCheckoutRates, (rates) =>
    rates ? getFreeRate(rates.rates_web) : {},
);

export const getIsActiveArchiveExtend = (state: StoreState) =>
    getCheckoutSlice(state).isActiveArchiveExtend;

export const getSelectedArchiveExtendInformation = (state: StoreState) =>
    getCheckoutSlice(state).selectedArchiveExtendInformation;

export const getSelectedArchiveExtend = (state: StoreState) =>
    getCheckoutSlice(state).selectedArchiveExtend;

export const getWebRatesToExtend = createSelector(getCheckoutRates, (rates) =>
    rates ? rates.rates_web.filter((rate) => rate.can_extend) : [],
);

export const getWebRatesToPurchase = createSelector(getCheckoutRates, (rates) =>
    rates ? rates.rates_web.filter((rate) => rate.can_buy) : [],
);

export const getIntegrationRate = createSelector(getCheckoutRates, (rates) =>
    rates ? rates.rates_integration[0] : {},
);

export const getCheckoutRatesUrl = (state: StoreState) =>
    getCheckoutSlice(state).checkoutRatesUrl;

export const getCheckoutIsLoading = (state: StoreState) =>
    getCheckoutSlice(state).isLoading;

export const getCheckoutIsAmountError = (state: StoreState) =>
    getCheckoutSlice(state).isAmountError;

export const getPrice = (state: StoreState) => getCheckoutSlice(state).price;

export const getExtendsPrice = (state: StoreState) =>
    getCheckoutSlice(state).extendPrice;
